import { error, json } from "@sveltejs/kit";
import { p as prisma } from "../../../../../chunks/prisma.js";
import { K as KEY, A as API_CLIENT_ID, S as SERVICE_ID, a as SECRET } from "../../../../../chunks/private.js";
import { createHmac } from "node:crypto";
const POST = async ({ locals: { user }, request, url: { origin } }) => {
  if (!user) return error(401, "Unauthorized");
  const body = await request.json().catch(() => ({}));
  const { productId, documentId, amount } = body || {};
  if (!productId || !documentId || !amount) return error(400, "Missing required fields");
  const doc = await prisma.productDocument.findUnique({ where: { id: Number(documentId) } });
  if (!doc || doc.productId !== Number(productId)) return error(404, "Document not found for product");
  const billRefNumber = `DOC-${Date.now()}-${user.id}-${documentId}`;
  const payment = await prisma.payment.create({
    data: {
      userId: user.id,
      amount: Number(amount),
      provider: "PESAFLOW",
      status: "PENDING",
      providerRef: billRefNumber,
      rawPayload: { type: "DOCUMENT_PURCHASE", productId: Number(productId), documentId: Number(documentId) }
    }
  });
  const paymentDetails = {
    apiClientID: API_CLIENT_ID,
    amountExpected: Number(amount),
    serviceID: SERVICE_ID,
    clientIDNumber: user.idNumber || "0",
    currency: "KES",
    billRefNumber,
    billDesc: `Document: ${doc.originalName}`,
    clientName: user.name || user.email,
    secret: SECRET
  };
  const dataString = [
    paymentDetails.apiClientID,
    paymentDetails.amountExpected,
    paymentDetails.serviceID,
    paymentDetails.clientIDNumber,
    paymentDetails.currency,
    paymentDetails.billRefNumber,
    paymentDetails.billDesc,
    paymentDetails.clientName,
    paymentDetails.secret
  ].join("");
  const secureHash = createHmac("sha256", KEY).update(dataString).digest("base64");
  return json({
    paymentId: payment.id,
    paymentDetails: {
      ...paymentDetails,
      secureHash,
      callBackURLOnSuccess: `${origin}/api/document/confirm?ref=${encodeURIComponent(billRefNumber)}`,
      callBackURLOnFail: `${origin}/product/${productId}`,
      notificationURL: `${origin}/api/document/notification`,
      clientEmail: user.email,
      clientMSISDN: user.phoneNumber || "0700000000",
      pictureURL: `${origin}/kLawLogo.png`
    }
  });
};
export {
  POST
};
